<div class="filter-row p-10">
  <div class="filter-controls">

    <mat-form-field appearance="outline" class="filter-field hide-hint">
      <mat-label>{{ 'LABEL.SEARCH_LABEL' | translate }}</mat-label>
      <input matInput [formControl]="patientSearchControl" placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }}" />
      <mat-icon matSuffix>
        <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
      </mat-icon>
    </mat-form-field>
    <mat-form-field appearance="outline" class="filter-field hide-hint" *ngIf="isAdmin || isDoctor">
      <mat-label>{{ 'LABEL.DOCTORS' | translate }}</mat-label>
      <input type="text" matInput placeholder="Search doctors" [formControl]="doctorControls"
        [matAutocomplete]="doctorAuto" />
      <mat-autocomplete #doctorAuto="matAutocomplete">
        <mat-option *ngFor="let doc of filteredDoctorList$ | async" [value]="doc"
          (onSelectionChange)="onDoctorToggle(doc)">
          <mat-checkbox [checked]="isDoctorSelected(doc.id)" (change)="onDoctorToggle(doc)"
            (click)="$event.stopPropagation()">
            {{ doc.name }}
          </mat-checkbox>
        </mat-option>
      </mat-autocomplete>
      <mat-icon matSuffix>
        <i-tabler name="chevron-down" class="icon-18 d-flex m-t-2"></i-tabler>
      </mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field hide-hint date-range-field">
      <mat-label>{{ 'LABEL.DATE_RANGE' | translate }}</mat-label>
      <mat-date-range-input [rangePicker]="rangePicker" [max]="maxDate">
        <input matStartDate [formControl]="startDateControl" readonly>
        <input matEndDate [formControl]="endDateControl" readonly>
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker color="primary"></mat-date-range-picker>
    </mat-form-field>

    <button mat-flat-button color="primary" (click)="loadReport()">
      {{ 'LABEL.SEARCH_LABEL' | translate }}
    </button>

    <button mat-stroked-button (click)="clearFilters()">
      {{ 'LABEL.CLEAR' | translate }}
    </button>
  </div>

  <a mat-icon-button (click)="printReport()" matTooltip="{{ 'BUTTON.BTN_PRINT' | translate }}" *ngIf="dataSource.data.length > 0">
    <i-tabler name="printer" class="text-primary icon-25 d-flex"></i-tabler>
  </a>
</div>

<mat-card>
  <mat-card-content>
    @if (isLoading) {
    <div class="d-flex justify-content-center p-y-24">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
    } @else if (dataSource.filteredData.length === 0) {
    <div class="text-center p-y-24">
      <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
    </div>
    } @else {
    <div class="table-responsive table-scroll-container-full">
      <table mat-table [dataSource]="dataSource" class="w-100">
        <ng-container matColumnDef="patientName">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.PATIENT_NAME' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="f-w-600">{{ row.patientName }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="billNo">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.BILL_NO' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.billNo }}</td>
        </ng-container>

        <ng-container matColumnDef="billAmount">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'LABEL.BILL_AMOUNT' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="text-right">{{ row.billAmount | number:'1.2-2' }}</td>
        </ng-container>

        <ng-container matColumnDef="paidAmount">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'LABEL.PAID_AMOUNT' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="text-right text-paid">{{ row.paidAmount | number:'1.2-2' }}</td>
        </ng-container>

        <ng-container matColumnDef="pendingAmount">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'LABEL.PENDING_AMOUNT' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="text-right" [class.text-warn]="row.pendingAmount > 0">
            {{ row.pendingAmount | number:'1.2-2' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="billDate">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.BILL_DATE' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.billDate | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="paymentStatus">
          <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.PAYMENT_STATUS' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge" [ngClass]="getStatusClass(row.paymentStatus)">
              {{ getStatusLabel(row.paymentStatus) }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="f-w-700"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="cursor-pointer"
          (click)="openBillDialog(row)">
        </tr>
      </table>
    </div>
    }
    <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}"
      [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" [pageSize]="10">
    </mat-paginator>
  </mat-card-content>
</mat-card>